import { Actions, Mutations } from '@/store/enums/StoreEnums';
// used as @Module/@Action/@Mutation decorators
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Action, Mutation, Module, VuexModule } from 'vuex-module-decorators';

interface Breadcrumb {
  title: string;
  pageBreadcrumbPath: Array<string>;
}

export interface IBreadcrumbLink {
  text: string;
  routeData?: {
    name: string;
    params?: {
      [key: string]: string | number;
    };
    query?: {
      [key: string]: string | number;
    };
  };
}

interface StoreInfo {
  breadcrumbs: Breadcrumb;
  breadcrumbLinks: Array<IBreadcrumbLink>;
}

@Module
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default class BreadcrumbsModule extends VuexModule implements StoreInfo {
  breadcrumbs = {} as Breadcrumb;
  breadcrumbLinks = [] as Array<IBreadcrumbLink>;

  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getBreadcrumbs(): Breadcrumb {
    return this.breadcrumbs;
  }

  /**
   * Get breadcrumb array for current page
   * @returns object
   */
  get pageBreadcrumbPath(): Array<string> {
    return this.breadcrumbs.pageBreadcrumbPath;
  }

  /**
   * Get current page title
   * @returns string
   */
  get pageTitle(): string {
    return this.breadcrumbs.title;
  }

  get breadcrumbLinksItems(): Array<IBreadcrumbLink> {
    return this.breadcrumbLinks;
  }

  @Mutation
  [Mutations.SET_BREADCRUMB_MUTATION](payload) {
    this.breadcrumbs = payload;
  }

  @Mutation
  [Mutations.SET_BREADCRUMB_LINKS_MUTATION](payload: Array<IBreadcrumbLink>) {
    this.breadcrumbLinks = payload;
  }

  @Action
  [Actions.SET_BREADCRUMB_ACTION](payload) {
    this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
  }

  @Action
  [Actions.SET_BREADCRUMB_ITEMS_ACTION](payload: Array<IBreadcrumbLink>) {
    this.context.commit(Mutations.SET_BREADCRUMB_LINKS_MUTATION, payload);
  }
}
